module.exports = __webpack_public_path__ + "img/undraw_kh.8d93a087.svg";